import React from 'react';
import Navbar from '../Page/Shared/Navbar/Navbar';
import { Outlet } from 'react-router-dom';
import SideNavBarDashboard from '../Page/Dashboard/SideNavBarDashboard';

const DashBoardLayout = () => {

    return (
        <>
            <Navbar />
            <div className="bg-gray-100 dark:bg-gray-800">
                <div>
                    <SideNavBarDashboard/>
                </div>
                <div className="h-full min-h-screen pl-14 pt-4 pb-10 md:pl-64">
                    <div className="p-4">
                        <Outlet />
                    </div>
                </div>
            </div>
        </>
    );
};

export default DashBoardLayout;